<template>
  <main class="inner-page page-auth">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-11">
          <div class="content">
            <div class="row">
              <div class="col-lg-6 content-left">
                <div class="block text-center logo-wrapper">
                  <img src="../../assets/auth/images/spectorly-logo.svg" alt="Spectorly" class="logo" />
                </div>
                <div class="block text-center banner-wrapper">
                  <img src="../../assets/auth/images/icon-auth-banner.svg" alt="Auth banner" />
                </div>

                <div class="note">
                  Placez l’humain au coeur de votre Stratégie de
                  <span>Cyberdéfence</span>
                </div>
              </div>

              <div class="col-lg-6 content-right">
                <form class="c-form form-2 relative">
                  <h4>Renvoyer le mail d'activation?</h4>
                  <h2><span>Entrez l'adresse mail de votre compte</span></h2>
                  <div class="separator"></div>
                  <div class="form-group">
                    <label>E-mail </label>
                    <input type="email" class="form-control" placeholder="Votre Adresse email" v-model="email" />
                  </div>
                  <div style="height: 20px;"></div>
                  <div class="form-group">
                    <button @click="resendActivationMail" type="submit" class="c-btn c-btn--secondary block w-100">
                      <span v-if="!waitingAPIResponse">Renvoyer</span>
                      <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 30px;" />
                    </button>
                    <div class="back" style="padding: 2em 3em;">
                      <p class="text-center">
                        <a href="/signup" type="button" style="text-decoration: none;  
                      ">J'ai déjà un compte !</a>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container -->
    <!-- <transition name="fadeY" appear mode="out-in">
      <alert v-if="alertMe" :status="gAlertType" :message="gAlertMessage"></alert>
    </transition> -->
  </main>
</template>

<script>
// import { guestAPI } from '@/axios-api.js'
// import Alert from '@/components/shared/alert/Alert.vue'
import axios from "axios";
export default {
  name: 'ResendActivationView',
  components: {
    // Alert
  },
  data() {
    return {
      email: '',
      alertMe: false,
      gAlertMessage: '',
      gAlertType: '',
      waitingAPIResponse: false,
      waitingAPIResponse2: false,
    }
  },
  methods: {
    displayError(error, type = 'alert-ok') {
      this.gAlertMessage = error
      this.gAlertType = type
      this.alertMe = true
      setTimeout(() => {
        this.alertMe = false
      }, 5000);
    },
    resendActivationMail() {
      if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email)) {
        this.displayError('Oups ! Veuillez entrer un email correct.', 'alert-no')
      }
      else {
        this.waitingAPIResponse = true
        axios.post(`${process.env.VUE_APP_BASE_URL}accounts/resend-email-activate-account/`, {
          email: this.email,
        })
          .then(response => {
            if (response.status == 200) {
              this.$emit('emailSent')
              this.displayError('Veuillez consulter votre boite de réception email.', 'alert-yes')
              this.waitingAPIResponse = false
            }
            else {
              this.displayError('Oups ! something went wrong.', 'alert-no')
              this.waitingAPIResponse = false
            }
          })
          .catch(error => {
            // console.log(error)
            if (error.response) {
              this.displayError(error.response.data.message, 'alert-no', 10000)
            }
            else if (error.request) {
              this.displayError('The request was made but no response was received. Please check your network.', 'alert-no', 8000)
            }
            else {
              this.displayError('Oups ! something went wrong.', 'alert-no', 5000)
            }
            this.waitingAPIResponse = false
          })
      }
    }
  },
  mounted() {
    this.waitingAPIResponse2 = true
    axios.get(`${process.env.VUE_APP_BASE_URL}pub?key=REACTIVATE`).then(response => {
      if (response.status == 200) {
        this.pub = response.data[0]
      }
      else {
        console.log('Something went wrong !')
      }
      this.waitingAPIResponse2 = false
    }).catch(() => {
      console.log('Something went wrong !')
      this.waitingAPIResponse2 = false
    });
  }
}
</script>

<style scoped>
/* .flex{
    padding-right: 10px;
    padding-left: 10px;
  } */
.auth-form-link .forgot-password {
  cursor: pointer;
  text-decoration: underline;
}

.auth-form-link a {
  color: #476388;
}

.c-btn {
  font-weight: 600;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  white-space: nowrap;
  display: inline-block;
  text-align: center;
  outline: none;
  border: none;
  transition: all .3s ease
}

.c-btn--sm {
  padding: 10px 15px;
  font-size: 14px;
  border-radius: 5px
}

@media screen and (min-width: 1200px) {
  .c-btn {
    font-size: 18px;
    padding: 18px 25px;
    border-radius: 10px
  }

  .c-btn--sm {
    padding: 10px 20px;
    font-size: 16px
  }
}

.c-btn--primary {
  background-color: #06bbc4;
  color: #fff
}

.c-btn--secondary {
  background-color: #262f44;
  color: #fff
}

.c-btn--secondary-hover-primary:hover {
  background-color: #06bbc4;
  color: #fff
}

.c-btn--primary-hover-white:hover {
  background-color: #fff;
  color: #262f44
}

.c-btn--primary-hover-secondary:hover {
  background-color: #262f44;
  color: #fff
}

.c-btn--secondary-hover-white:hover {
  background-color: #262f44;
  color: #fff
}

.c-btn--primary-ghost {
  background-color: rgba(0, 0, 0, 0);
  position: relative;
  color: #06bbc4
}

.c-btn--primary-ghost::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 3px solid #06bbc4;
  border-radius: 5px
}

@media screen and (min-width: 1200px) {
  .c-btn--primary-ghost::before {
    border-radius: 10px
  }
}

.c-btn--primary-ghost:hover {
  box-shadow: 0 0 23px 0 rgba(6, 187, 196, .5);
  color: #06bbc4
}

.c-btn--primary-glow {
  box-shadow: 0 22px 20px -25px rgba(6, 187, 196, .9)
}

.c-btn--shadow {
  box-shadow: 0 6px 12px 0 rgba(18, 38, 85, .28)
}

.c-section-header {
  font-size: 20px;
  font-weight: 700;
  color: #262f44;
  line-height: 1.5;
  margin-bottom: 15px;
  max-width: 855px;
  margin-left: auto;
  margin-right: auto
}

.c-section-header span {
  color: #06bbc4
}

.c-section-header.white {
  color: #fff
}

.c-section-header.underline::after {
  content: "";
  display: block;
  height: 6px;
  border-radius: 100px;
  background-color: #06bbc4;
  max-width: 125px;
  margin: 16px auto 30px
}

@media screen and (min-width: 1200px) {
  .c-section-header {
    font-size: 32px
  }
}

.c-checkbox-content ul {
  list-style-type: none;
  padding: 0;
  margin: 0 0 10px;
  font-size: 12px
}

.c-checkbox-content ul li {
  margin-bottom: 15px;
  padding-left: 20px;
  position: relative
}

.c-checkbox-content ul li::before {
  content: "";
  display: block;
  height: 12px;
  width: 12px;
  position: absolute;
  left: 0;
  top: 3px;
  background: url("../../assets/auth/images/icon-check.svg") no-repeat center center/contain
}

@media screen and (min-width: 992px) {
  .c-checkbox-content ul {
    font-size: 16px;
    margin-bottom: 40px
  }

  .c-checkbox-content ul li::before {
    top: 7px
  }
}

@media screen and (min-width: 1200px) {
  .c-checkbox-content ul {
    font-size: 18px;
    margin-bottom: 60px
  }

  .c-checkbox-content ul li {
    margin-bottom: 32px;
    padding-left: 38px
  }

  .c-checkbox-content ul li::before {
    height: 30px;
    width: 30px;
    top: 1px
  }
}

.c-checkbox-content .c-btn {
  min-width: 142px;
  margin-left: 20px
}

@media screen and (min-width: 1200px) {
  .c-checkbox-content .c-btn {
    min-width: 265px
  }
}

.c-note {
  font-size: 16px;
  font-weight: 600;
  color: #7d7d7d;
  line-height: 1.8;
  display: flex;
  align-items: center
}

.c-note .text::after {
  content: "";
  display: block;
  max-width: 140px;
  height: 5px;
  background-color: #d9d9d9;
  border-radius: 10px;
  margin: 10px 0 20px
}

@media screen and (min-width: 1200px) {
  .c-note .text::after {
    height: 10px
  }
}

.c-note span {
  color: #06bbc4;
  font-weight: 700
}

@media screen and (min-width: 992px) {
  .c-note {
    font-size: 18px
  }
}

@media screen and (min-width: 1200px) {
  .c-note {
    font-size: 25px
  }
}

.c-form label {
  display: block;
  margin-bottom: 4px;
  font-size: 14px
}

.c-form .form-group {
  margin-bottom: 24px
}

.c-form .input-group-text {
  background-color: #fff;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0
}

.c-form .input-group-text img {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 24px
}

@media screen and (min-width: 1200px) {
  .c-form .input-group-text {
    height: 58px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px
  }
}

.c-form .form-control {
  height: 42px;
  padding-left: 16px;
  outline: none;
  box-shadow: none
}

.c-form .form-control::placeholder {
  color: #d9d9d9
}

@media screen and (min-width: 1200px) {
  .c-form .form-control {
    height: 58px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px
  }
}

.c-form .c-btn {
  height: 60px;
  padding-top: 0;
  padding-bottom: 0
}

.c-form p {
  font-weight: 600;
  font-size: 18px;
  color: #262f44
}

.c-form p a {
  font-weight: 600;
  color: #06bbc4;
  text-decoration: underline
}

.c-form.form-2 label {
  font-weight: 600
}

.c-form.form-2 .form-control {
  border-radius: 10px
}

.c-accordion .accordion-item {
  border: none;
  padding-bottom: 10px
}

.c-accordion .accordion-header .accordion-button {
  font-size: 16px;
  color: #000;
  background-color: #e6f8f9;
  padding: 8px 14px;
  font-weight: 500;
  border-radius: 5px;
  box-shadow: none
}

@media screen and (min-width: 992px) {
  .c-accordion .accordion-header .accordion-button {
    font-size: 18px
  }
}

.c-accordion .accordion-body {
  background-color: #fafafa;
  font-weight: 300;
  padding: 20px 16px;
  border-radius: 5px;
  line-height: 1.4;
  font-size: 14px
}

@media screen and (min-width: 992px) {
  .c-accordion .accordion-body {
    font-size: 16px
  }
}

.c-card-block .block-title {
  font-size: 18px;
  font-weight: 600;
  padding: 10px 20px;
  background-color: #06bbc4;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 10px
}

@media screen and (min-width: 992px) {
  .c-card-block .block-title {
    font-size: 24px
  }
}

.c-card-block .block-body {
  background-color: #f7f7f7;
  padding: 20px;
  border-radius: 5px;
  color: #7d7d7d;
  font-size: 14px;
  line-height: 1.4
}

@media screen and (min-width: 992px) {
  .c-card-block .block-body {
    font-size: 18px;
    line-height: 1.6
  }
}

.c-switch-toggler {
  display: inline-flex;
  margin: 0 auto;
  background: #e8e8e8;
  border-radius: 50px;
  padding: 10px;
  position: relative
}

.c-switch-toggler .item {
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  color: #262f44;
  padding: 12px 16px;
  cursor: pointer;
  position: relative;
  z-index: 1;
  transition: all .4s ease
}

.c-switch-toggler .item.active {
  color: #fff
}

.c-switch-toggler .selector {
  border-radius: 50px;
  background-color: #262f44;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  transition: all .3s ease
}

@media screen and (min-width: 992px) {
  .c-switch-toggler {
    padding: 15px
  }

  .c-switch-toggler .item {
    font-size: 14px;
    padding: 16px 24px
  }
}

.switch-item {
  display: none
}

.switch-item.active {
  display: block
}

.c-tab .tab-header {
  background-color: #3d4b6a;
  border-radius: 50px;
  align-items: center;
  padding: 6px;
  margin-bottom: 28px;
  position: relative;
  display: none
}

@media screen and (min-width: 992px) {
  .c-tab .tab-header {
    display: inline-flex
  }
}

.c-tab .tab-header .tab-item {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 50px;
  padding: 8px 18px;
  position: relative;
  z-index: 1;
  cursor: pointer;
  white-space: nowrap
}

.c-tab .tab-header .tab-item.active {
  color: #262f44
}

@media screen and (min-width: 992px) {
  .c-tab .tab-header .tab-item {
    font-size: 14px
  }
}

.c-tab .tab-header .selector {
  border-radius: 50px;
  background-color: #06bbc4;
  position: absolute;
  top: 6px;
  left: 0;
  transition: all .3s ease
}

.c-tab .tab-body {
  padding: 32px 0
}

.c-tab .tab-body .tab-item.active {
  display: block
}

@media screen and (min-width: 992px) {
  .c-tab .tab-body .tab-item {
    display: none
  }
}

.c-tab .tab-body .tab-item {
  border-bottom: 1px solid rgba(255, 255, 255, .5);
  margin-bottom: 5px
}

.c-tab .tab-body .tab-title {
  font-weight: 600;
  font-size: 16px;
  color: #fff;
  padding: 10px 15px;
  position: relative;
  cursor: pointer
}

.c-tab .tab-body .tab-title::after {
  content: "";
  display: inline-block;
  position: absolute;
  right: 0;
  top: 14px;
  border-top: 10px solid #fff;
  border-left: 10px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0)
}

.c-tab .tab-body .tab-content {
  padding: 0 15px;
  display: none
}

.c-tab .tab-body .tab-content .tab-item__item {
  width: 100%;
  margin-bottom: 15px
}

.c-tab .tab-body .tab-item.active .tab-title::after {
  content: "";
  border-bottom: 10px solid #fff;
  border-top: none;
  border-left: 10px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0)
}

.c-tab .tab-body .tab-item.active .tab-content {
  display: block
}

@media screen and (min-width: 992px) {
  .c-tab .tab-body .tab-item {
    border: none;
    margin-bottom: 0
  }

  .c-tab .tab-body .tab-title {
    display: none
  }

  .c-tab .tab-body .tab-content.active {
    display: block
  }

  .c-tab .tab-body .tab-content .tab-item__item {
    margin-bottom: 30px;
    max-width: 33.333%
  }
}

@media screen and (min-width: 1200px) {
  .c-tab .tab-body .tab-content.active {
    display: block
  }

  .c-tab .tab-body .tab-content .tab-item__item {
    max-width: 20%
  }
}

.c-icon-card {
  background-color: #262f44;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, .1);
  border-radius: 15px;
  text-align: center;
  padding: 16px;
  max-width: 290px
}

.c-icon-card .icon {
  display: block;
  margin-bottom: 15px
}

.c-icon-card .text {
  display: block;
  color: #fff;
  font-size: 14px;
  font-weight: 500
}

@media screen and (min-width: 992px) {
  .c-icon-card .text {
    font-size: 16px
  }
}

.c-icon-card-2 {
  background: #fff;
  border-radius: 20px;
  text-align: left;
  border: 1px solid #d9d9d9;
  padding: 30px 16px;
  display: flex;
  align-items: center;
  flex-direction: column
}

.c-icon-card-2 .icon {
  max-width: 170px;
  flex: 0 0 170px;
  margin-bottom: 18px
}

.c-icon-card-2 .text {
  text-align: left;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
  padding-top: 65px
}

.c-icon-card-2 .text::before {
  background-color: #d9d9d9;
  position: absolute;
  max-width: 180px;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  top: 0;
  content: "";
  display: block;
  margin: 0 auto
}

.c-icon-card-2 .text h3 {
  color: #06bbc4;
  font-size: 20px;
  font-weight: 600
}

.c-icon-card-2 .text .desc {
  font-size: 14px
}

.c-icon-card-2--secondary {
  background-color: #262f44;
  color: #fff
}

.c-icon-card-2--secondary .text .desc {
  color: #fff
}

@media screen and (min-width: 992px) {
  .c-icon-card-2 {
    border-radius: 40px;
    padding: 40px;
    flex-direction: row
  }

  .c-icon-card-2 .icon {
    margin-right: 40px;
    max-width: 190px;
    flex: 0 0 190px
  }

  .c-icon-card-2 .text {
    border-left: 1px solid #d9d9d9;
    padding-left: 80px;
    padding-right: 80px;
    padding-top: 0
  }

  .c-icon-card-2 .text::before {
    display: none
  }

  .c-icon-card-2 .text h3 {
    font-size: 32px
  }

  .c-icon-card-2 .text .desc {
    font-size: 22px
  }
}

.c-text-card {
  background-color: #fff;
  padding: 30px 36px 60px;
  border-radius: 5px;
  box-shadow: 0 0 55.6px 0 rgba(6, 187, 196, .12);
  transition: all .5s ease
}

.c-text-card:hover {
  background-color: #262f44
}

.c-text-card:hover .text-card__title,
.c-text-card:hover .text-card__description {
  color: #fff
}

.c-text-card .text-card__title {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 32px;
  color: #262f44;
  padding-right: 30px
}

.c-text-card .text-card__description {
  font-size: 14px;
  color: #262f44;
  line-height: 1.6;
  padding-right: 30px
}

.bg-secondary {
  background-color: #262f44 !important
}

.bg-light-green {
  background-color: #f0fbfb
}

body {
  font-family: "Poppins"
}

* {
  box-sizing: border-box
}

html {
  overflow: auto
}

body {
  overflow-x: hidden;
  overflow-y: auto
}

img {
  max-width: 100%
}

.-mx-16 {
  margin: 0 -16px !important
}

.px-16 {
  padding: 0 16px !important
}

.slick-track {
  display: flex
}

.slick-track .slick-slide {
  display: flex;
  height: auto;
  align-items: center;
  justify-content: center
}

.slick-arrow {
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99
}

.slick-arrow__prev {
  left: 0
}

.slick-arrow__next {
  right: 0
}

.slick-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  margin: 0;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0
}

.slick-dots li {
  padding: 0 3px
}

.slick-dots li button {
  height: 15px;
  width: 15px;
  border-radius: 100%;
  background-color: #d9d9d9;
  border: none;
  text-indent: -9999px;
  outline: none;
  box-shadow: none
}

.slick-dots li.slick-active button {
  background-color: #262f44
}

.inner-page {
  padding-top: 120px;
  padding-bottom: 60px
}

@media screen and (min-width: 992px) {
  .inner-page {
    padding-top: 130px
  }
}

@media screen and (min-width: 1200px) {
  .inner-page {
    padding-top: 140px
  }
}

.inner-page .c-section-header {
  margin-bottom: 30px
}

@media screen and (min-width: 992px) {
  .inner-page .c-section-header {
    margin-bottom: 52px
  }
}

@media screen and (min-width: 1200px) {
  .inner-page .c-section-header {
    margin-bottom: 70px
  }
}

.inner-page .page-header {
  background-color: #262f44;
  color: #fff;
  padding: 30px 20px;
  border-radius: 5px;
  text-align: center;
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 10px
}

@media screen and (min-width: 992px) {
  .inner-page .page-header {
    font-size: 46px
  }
}

.inner-page .page-sub-header {
  background-color: #06bbc4;
  padding: 16px 20px;
  font-size: 20px;
  color: #262f44;
  text-align: center;
  border-radius: 5px;
  margin-bottom: 50px
}

@media screen and (min-width: 992px) {
  .inner-page .page-sub-header {
    font-size: 28px
  }
}

.rounded-3 {
  border-radius: 25px !important
}

.pt-0 {
  padding-top: 0 !important
}

.pb-0 {
  padding-bottom: 0 !important
}

.-mx-10 {
  margin: 0 -10px
}

.px-10 {
  padding: 0 10px
}

.mb-40 {
  margin-bottom: 40px
}

.m-header {
  padding: 14px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999
}

@media screen and (min-width: 992px) {
  .m-header {
    padding: 8px 0
  }
}

.m-nav {
  z-index: 99;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  padding: 16px 32px 42px;
  min-height: 100vh;
  max-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #262f44;
  -webkit-transform: translateX(100%);
  -moz-transform: translateX(100%);
  transform: translateX(100%);
  visibility: hidden;
  transition: all .3s ease
}

.m-nav.active {
  -webkit-transform: translateX(0px);
  -moz-transform: translateX(0px);
  transform: translateX(0px);
  visibility: visible
}

.m-nav .m-nav__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 42px
}

@media screen and (min-width: 992px) {
  .m-nav .m-nav__header {
    display: none
  }
}

.m-nav .nav-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  list-style-position: outside
}

.m-nav .nav-menu--item {
  margin-bottom: 26px
}

.m-nav .nav-menu-link {
  text-decoration: none;
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 14px
}

.m-nav .nav-menu-link .menu-icon {
  margin-right: 20px;
  display: block;
  height: 24px;
  width: 24px;
  overflow: hidden;
  position: relative
}

.m-nav .nav-menu-link .menu-icon img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: contain;
  object-position: center;
  transition: all .3s ease
}

.m-nav .nav-menu-link .menu-icon img.second-icon {
  opacity: 0
}

.m-nav .nav-menu-link .menu-name {
  display: block;
  transition: all .3s ease
}

.m-nav .nav-menu-link:hover {
  color: #06bbc4
}

.m-nav .nav-menu-link:hover .menu-icon img.second-icon {
  opacity: 1
}

.m-nav .nav-menu-link:hover .menu-icon img.main-icon {
  opacity: 0
}

.m-nav .nav-menu--item.active .nav-menu-link {
  color: #06bbc4;
  font-weight: 500
}

.m-nav .nav-menu--item.active .nav-menu-link img.second-icon {
  opacity: 1
}

.m-nav .nav-menu--item.active .nav-menu-link img.main-icon {
  opacity: 0
}

.m-nav .nav-menu--item--dropdown .nav-menu-link::after {
  content: "";
  display: block;
  height: 15px;
  width: 15px;
  background: url("../../assets/auth/images/icon-chevron-down.svg") no-repeat center center/contain;
  margin-left: 46px;
  transition: all .3s ease
}

.m-nav .nav-menu--item--dropdown .nav-menu-dropdown {
  display: none
}

.m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul {
  padding-left: 44px;
  list-style-type: none
}

.m-nav .nav-menu--item--dropdown .nav-menu-dropdown a {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0)
}

.m-nav .nav-menu--item--dropdown .nav-menu-dropdown a:hover {
  border-bottom-color: #06bbc4
}

.m-nav .nav-menu--item--dropdown .nav-menu-dropdown a::after {
  content: "";
  display: block;
  height: 20px;
  width: 20px;
  margin-left: 10px;
  background: url("../../assets/auth/images/icon-long-arrow-right.svg") no-repeat center center/contain
}

.m-nav .nav-menu--item--dropdown .nav-menu-dropdown a .icon {
  display: none
}

.m-nav .nav-menu--item--dropdown .nav-menu-dropdown a .text .title {
  color: #fff;
  font-size: 12px
}

.m-nav .nav-menu--item--dropdown .nav-menu-dropdown a .text .desc {
  display: none
}

.m-nav .nav-menu--item--dropdown.active .nav-menu-link::after {
  transform: rotate(180deg);
  background: url("../../assets/auth/images/icon-chevron-down-primary.svg") no-repeat center center/contain
}

@media screen and (min-width: 992px) {
  .m-nav .nav-menu {
    display: flex;
    align-items: center;
    overflow: initial
  }

  .m-nav .nav-menu--item {
    margin-bottom: 0;
    margin-right: 16px
  }

  .m-nav .nav-menu-link {
    padding: 14px 0
  }

  .m-nav .nav-menu-link .menu-icon {
    margin-right: 4px
  }

  .m-nav .nav-menu--item--dropdown {
    position: relative
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-link::after {
    display: none
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 382px;
    background: #fff;
    padding: 15px 16px;
    border-radius: 10px;
    visibility: hidden;
    opacity: 0;
    z-index: -1;
    display: none;
    box-shadow: 0 6px 6px 0 rgba(38, 47, 68, .28);
    transition: all .3s ease-in
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown-2 {
    min-width: 288px
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul {
    margin: 0;
    padding: 0;
    list-style: none
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul li {
    margin-bottom: 10px
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul li:last-child {
    margin-bottom: 0
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul li.active a {
    background-color: rgba(38, 47, 68, .05)
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul li.active a .icon {
    background-color: #fff;
    color: #06bbc4
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul li.active a .icon .menu-icon-1 {
    display: none
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul li.active a .icon .menu-icon-2 {
    display: block
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown ul li.active a .text .title {
    color: #06bbc4
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a {
    display: flex;
    line-height: 1.2;
    padding: 5px 10px;
    border-radius: 10px;
    align-items: center;
    border-bottom: none;
    transition: all .3s ease
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a::after {
    display: none
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a .icon {
    display: block;
    height: 48px;
    width: 48px;
    max-width: 48px;
    flex: 0 0 48px;
    border-radius: 100px;
    transition: all .3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #262f44;
    font-size: 22px;
    font-weight: 600
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a .icon .menu-icon-2 {
    display: none
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a .text {
    display: block;
    color: #262f44;
    padding-left: 18px;
    padding-right: 18px
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a .text .title {
    font-size: 14px;
    font-weight: 600;
    display: block;
    margin-bottom: 4px;
    color: #262f44;
    transition: all .3s ease
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a .text .desc {
    display: block;
    font-size: 10px;
    line-height: 1.6;
    color: #7d7d7d
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a:hover {
    background-color: rgba(38, 47, 68, .05)
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a:hover .icon {
    background-color: #fff;
    color: #06bbc4
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a:hover .icon .menu-icon-1 {
    display: none
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a:hover .icon .menu-icon-2 {
    display: block
  }

  .m-nav .nav-menu--item--dropdown .nav-menu-dropdown a:hover .text .title {
    color: #06bbc4
  }

  .m-nav .nav-menu--item--dropdown:hover .nav-menu-link {
    color: #06bbc4
  }

  .m-nav .nav-menu--item--dropdown:hover .nav-menu-link .menu-icon {
    color: #06bbc4
  }

  .m-nav .nav-menu--item--dropdown:hover .nav-menu-link .menu-icon img.main-icon {
    opacity: 0
  }

  .m-nav .nav-menu--item--dropdown:hover .nav-menu-link .menu-icon img.second-icon {
    opacity: 1
  }

  .m-nav .nav-menu--item--dropdown:hover .nav-menu-dropdown {
    visibility: visible;
    opacity: 1;
    z-index: 1;
    display: block
  }
}

@media screen and (min-width: 1200px) {
  .m-nav .nav-menu--item {
    margin-bottom: 0;
    margin-right: 30px
  }

  .m-nav .nav-menu-link {
    font-size: 16px
  }

  .m-nav .nav-menu-link .menu-icon {
    margin-right: 6px
  }
}

.m-nav .nav-button {
  background-color: #fff;
  padding: 8px 34px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  text-decoration: none;
  color: #fff;
  background-color: #06bbc4;
  font-size: 14px;
  line-height: 1.5;
  display: inline-block;
  transition: all .3s ease
}

.m-nav .nav-button:hover {
  background-color: #fff;
  color: #262f44
}

@media screen and (min-width: 992px) {
  .m-nav .nav-button {
    background-color: #fff;
    color: #06bbc4
  }

  .m-nav .nav-button:hover {
    background-color: #06bbc4;
    color: #fff
  }
}

@media screen and (min-width: 992px) {
  .m-nav {
    display: flex;
    align-items: center;
    position: relative;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    transform: translateX(0);
    padding: 0;
    min-height: initial;
    max-height: 100%;
    visibility: visible;
    overflow: initial
  }
}

.m-section {
  padding: 50px 0
}

@media screen and (min-width: 992px) {
  .m-section {
    padding: 100px 0
  }
}

.m-section-note {
  padding: 0 16px
}

.m-section-note .content {
  background-color: #fff;
  padding: 26px 20px;
  border-radius: 20px;
  box-shadow: 0 50px 50px 0 rgba(0, 0, 0, .12)
}

.m-section-note .content__note {
  padding: 20px 16px;
  background-color: #262f44;
  color: #fff;
  font-weight: 500;
  border-radius: 20px;
  position: relative;
  margin-top: 40px;
  margin-bottom: -80px;
  box-shadow: 0 50px 50px 0 rgba(0, 0, 0, .12)
}

.m-section-note .content__note span {
  color: #06bbc4
}

@media screen and (min-width: 1200px) {
  .m-section-note .content__note {
    max-width: 1015px;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    padding: 32px 48px
  }
}

@media screen and (min-width: 1200px) {
  .m-section-note .content {
    padding: 22px 34px 34px
  }
}

.m-section-note h2 {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.6
}

.m-section-note h2 span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .m-section-note h2 {
    font-size: 36px;
    line-height: 1.2
  }
}

.m-section-clients {
  padding: 0 16px
}

@media screen and (min-width: 992px) {
  .m-section-clients {
    box-shadow: 0 -26px 38px 0px rgba(0, 0, 0, .06)
  }
}

.m-section-clients .content {
  background-color: #fff;
  padding: 40px 20px;
  text-align: center;
  border-radius: 20px;
  box-shadow: 0 -26px 38px 0px rgba(0, 0, 0, .06)
}

@media screen and (min-width: 992px) {
  .m-section-clients .content {
    box-shadow: none
  }
}

.m-section-clients .clients .block {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 64px
}

.m-section-clients .clients .block img {
  display: block;
  object-fit: contain
}

.m-section-clients .clients .block:last-child {
  margin-bottom: 40px
}

@media screen and (min-width: 992px) {
  .m-section-clients .clients .block {
    margin-bottom: 0
  }
}

@media screen and (min-width: 992px) {
  .m-section-clients .clients {
    padding: 60px 110px
  }
}

@media screen and (min-width: 992px) {
  .m-section-clients {
    margin-bottom: 60px
  }
}

.m-packages {
  background-color: #262f44;
  padding: 52px 0
}

.m-packages .package-header {
  position: relative;
  padding-bottom: 36px
}

.m-packages .package-header .title {
  font-size: 24px;
  font-weight: 600
}

.m-packages .package-header .price {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 2px
}

.m-packages .package-header .desc {
  font-size: 12px
}

.m-packages .package-header::after {
  content: "";
  display: block;
  height: 2px;
  position: absolute;
  left: -24px;
  right: -24px;
  bottom: 18px;
  background: #47526f;
  background: linear-gradient(90deg, rgb(71, 82, 111) 0%, rgb(38, 47, 68) 100%)
}

.m-packages .package-list {
  margin-bottom: 30px
}

.m-packages .package-list ul {
  padding: 0;
  list-style-type: none
}

.m-packages .package-list ul li {
  margin-bottom: 8px;
  padding-left: 24px;
  position: relative;
  font-size: 12px
}

.m-packages .package-list ul li::before {
  content: "";
  height: 12px;
  width: 12px;
  display: block;
  position: absolute;
  left: 0;
  top: 2px;
  background: url("../../assets/auth/images/icon-check-normal-primary.svg") no-repeat center center/contain
}

.m-packages .package-item {
  padding: 24px;
  border: 1px solid #3d4b6a;
  border-radius: 14px;
  color: #fff
}

.m-packages .package-item .icon {
  margin-bottom: 10px
}

.m-packages .package-item button {
  font-weight: 600;
  font-size: 14px;
  border-radius: 8px;
  color: #262f44;
  padding: 9px 14px;
  border: none
}

.m-packages .package-item.starter .package-header .title {
  color: #72c9ce
}

.m-packages .package-item.starter button {
  background: #17969d;
  background: linear-gradient(90deg, rgb(23, 150, 157) 0%, rgb(133, 248, 255) 100%)
}

.m-packages .package-item.pro .package-header .title {
  color: #fce38a
}

.m-packages .package-item.pro .package-list ul li::before {
  background-image: url("../../assets/auth/images/icon-check-normal-yellow.svg")
}

.m-packages .package-item.pro button {
  background: #fce38a;
  background: linear-gradient(90deg, rgb(252, 227, 138) 0%, rgb(255, 240, 187) 100%)
}

.m-packages .package-item.business .package-header .title {
  color: #7bb8ff
}

.m-packages .package-item.business .package-list ul li::before {
  background-image: url("../../assets/auth/images/icon-check-normal-blue.svg")
}

.m-packages .package-item.business button {
  background: #7bb8ff;
  background: linear-gradient(90deg, rgb(123, 184, 255) 0%, rgb(203, 227, 255) 100%)
}

.m-packages .package-item.enterprise .package-header .title {
  color: #f08a5e
}

.m-packages .package-item.enterprise .package-list ul li::before {
  background-image: url("../../assets/auth/images/icon-check-normal-orange.svg")
}

.m-packages .package-item.enterprise button {
  background: #f08a5e;
  background: linear-gradient(90deg, rgb(240, 138, 94) 0%, rgb(255, 220, 205) 100%)
}

.m-packages .package-item.corporate .package-header .title {
  color: #9251fd
}

.m-packages .package-item.corporate .package-list ul li::before {
  background-image: url("../../assets/auth/images/icon-check-normal-purple.svg")
}

.m-packages .package-item.corporate button {
  background: #9251fd;
  background: linear-gradient(90deg, rgb(146, 81, 253) 0%, rgb(217, 193, 255) 100%)
}

.m-information-box .content {
  background-color: rgba(38, 47, 68, .8);
  border-radius: 10px;
  padding: 50px 30px
}

.m-information-box .content .title {
  color: #fff;
  font-weight: 800;
  margin-bottom: 16px;
  font-size: 24px
}

.m-information-box .content .title .icon {
  margin-right: 20px
}

.m-information-box .content .title span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .m-information-box .content .title {
    margin-bottom: 40px;
    font-size: 45px
  }
}

.m-information-box .content .description {
  color: #fff;
  max-width: 1140px
}

.m-information-box .content .description p:last-child {
  margin-bottom: 0
}

@media screen and (min-width: 992px) {
  .m-information-box .content .description {
    font-size: 24px
  }
}

.m-simulation {
  padding-top: 50px
}

@media screen and (min-width: 992px) {
  .m-simulation {
    padding-top: 100px
  }
}

.m-simulation .simulation-item {
  margin-bottom: 60px;
  position: relative
}

@media screen and (min-width: 992px) {
  .m-simulation .simulation-item {
    display: flex;
    justify-content: center;
    margin-bottom: 22px
  }
}

.m-simulation .simulation-item .icon {
  height: 150px;
  width: 150px;
  border: 1.5px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 100%;
  margin-bottom: 22.1px;
  margin-left: auto;
  margin-right: auto
}

.m-simulation .simulation-item .icon::before {
  height: 120px;
  width: 120px;
  border: 5px solid #06bbc4;
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 100%
}

.m-simulation .simulation-item .icon::after {
  display: none;
  content: "";
  max-width: 151px;
  width: 100%;
  height: 40px;
  position: absolute;
  top: 93.5%;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  z-index: 1;
  background: url("../../assets/auth/images/curve.svg") no-repeat center center/contain
}

.m-simulation .simulation-item .icon img {
  height: 60px;
  width: 60px
}

@media screen and (min-width: 992px) {
  .m-simulation .simulation-item .icon {
    height: 310px;
    width: 310px;
    border: 2.5px solid #000;
    margin-bottom: 0
  }

  .m-simulation .simulation-item .icon img {
    height: 125px;
    width: 125px
  }

  .m-simulation .simulation-item .icon::before {
    height: 250px;
    width: 250px;
    border: 25px solid #06bbc4
  }

  .m-simulation .simulation-item .icon::after {
    height: 67px;
    display: block
  }
}

.m-simulation .simulation-item .text {
  position: relative;
  text-align: center;
  max-width: 470px;
  margin: 0 auto
}

.m-simulation .simulation-item .text h3 {
  font-weight: 700;
  font-size: 16px;
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .m-simulation .simulation-item .text h3 {
    font-size: 25px
  }
}

.m-simulation .simulation-item .text p {
  font-size: 14px
}

@media screen and (min-width: 992px) {
  .m-simulation .simulation-item .text p {
    font-size: 20px
  }
}

.m-simulation .simulation-item .text::before {
  content: "";
  width: 285px;
  height: 65px;
  background: url("../../assets/auth/images/curve-line.svg") no-repeat top center/contain;
  position: absolute;
  top: -40px;
  left: -70px;
  display: none
}

@media screen and (min-width: 992px) {
  .m-simulation .simulation-item .text::before {
    display: block
  }
}

@media screen and (min-width: 992px) {
  .m-simulation .simulation-item .text {
    position: absolute;
    left: calc(50% + 220px);
    text-align: left;
    margin-left: 0
  }
}

.m-simulation .simulation-item:nth-child(even) .text::before {
  top: -40px;
  right: -70px;
  left: auto;
  background: url("../../assets/auth/images/curve-line-2.svg") no-repeat top center/contain
}

@media screen and (min-width: 992px) {
  .m-simulation .simulation-item:nth-child(even) .text {
    right: calc(50% + 220px);
    left: 0
  }
}

.m-simulation .simulation-item:last-child .icon::after {
  display: none
}

.m-steps .step-items {
  position: relative;
  padding: 0 25px
}

.m-steps .step-item {
  display: flex;
  align-items: flex-start;
  padding-bottom: 50px;
  position: relative
}

@media screen and (min-width: 992px) {
  .m-steps .step-item {
    padding-bottom: 115px
  }
}

.m-steps .step-item::after {
  content: "";
  display: block;
  width: 3px;
  background-color: #d9d9d9;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 20px
}

.m-steps .step-item:last-child {
  padding-bottom: 0
}

.m-steps .step-item:last-child::after {
  opacity: 0
}

.m-steps .step-item .count {
  font-size: 20px;
  font-weight: 600;
  color: #7b7b7b;
  position: relative;
  z-index: 1;
  max-width: 40px;
  height: 40px;
  width: 100%;
  background-color: #e6e6e6;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 10px solid #fff;
  transition: all .4s
}

@media screen and (min-width: 992px) {
  .m-steps .step-item .count {
    max-width: 70px;
    height: 70px;
    font-size: 38px;
    outline: 30px solid #fff
  }
}

.m-steps .step-item .text {
  padding-left: 20px;
  font-size: 16px;
  width: 100%
}

@media screen and (min-width: 992px) {
  .m-steps .step-item .text {
    padding-left: 80px;
    font-size: 30px;
    transition: all .4s
  }
}

@media screen and (min-width: 992px) {
  .m-steps .step-item::after {
    left: 32px;
    width: 5px
  }
}

.m-steps .step-item.active::after {
  background: #06bbc4;
  transition: all .4s
}

@media screen and (min-width: 992px) {
  .m-steps .step-item.active .count {
    background: #06bbc4;
    color: #fff
  }

  .m-steps .step-item.active .text {
    font-size: 38px;
    font-weight: 700
  }

  .m-steps .step-item.active .c-btn {
    font-size: 25px
  }
}

.m-highlights {
  background-color: rgba(38, 47, 68, .9);
  color: #fff;
  padding: 40px 30px 50px;
  border-radius: 40px
}

@media screen and (min-width: 992px) {
  .m-highlights {
    padding: 50px 60px 100px
  }
}

.m-highlights h2 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  text-align: center;
  margin-bottom: 30px
}

.m-highlights h2 span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .m-highlights h2 {
    font-size: 30px;
    margin-bottom: 115px
  }
}

.m-highlights .highlight-item {
  background-color: #262f44;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
  padding: 12px 56px;
  position: relative
}

.m-highlights .highlight-item::before {
  content: "";
  display: block;
  background: url("../../assets/auth/images/icon-highlight-arrow.svg") no-repeat center center/contain;
  position: absolute;
  width: 15px;
  height: 15px;
  top: 50%;
  transform: translateY(-50%);
  left: 15px
}

@media screen and (min-width: 992px) {
  .m-highlights .highlight-item::before {
    left: 35px;
    height: 40px;
    width: 40px
  }
}

.m-highlights .highlight-item:hover {
  background-color: #06bbc4;
  color: #262f44
}

.m-highlights .highlight-item:hover::before {
  background: url("../../assets/auth/images/icon-highlight-arrow-secondary.svg") no-repeat center center/contain
}

@media screen and (min-width: 992px) {
  .m-highlights .highlight-item {
    font-size: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 30px 120px
  }
}

.m-testimonial .title {
  font-weight: 700;
  font-size: 16px;
  color: #262f44;
  margin-bottom: 80px
}

.m-testimonial .title span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .m-testimonial .title {
    font-size: 42px;
    margin-bottom: 110px
  }
}

.m-testimonial .testimonial-card {
  background-color: #fff;
  padding: 50px 64px 20px;
  border-radius: 5px;
  box-shadow: 0 0 55.6px 0 rgba(6, 187, 196, .12);
  max-width: 370px
}

.m-testimonial .testimonial-card .icon {
  margin-bottom: 20px;
  text-align: center
}

.m-testimonial .testimonial-card .text {
  font-size: 14px;
  color: #646464;
  margin-bottom: 60px;
  text-align: center
}

.m-testimonial .testimonial-card .name {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  text-align: right
}

.m-about {
  background: #262f44;
  border-top: 1px solid rgba(6, 187, 196, .24);
  color: #fff
}

.m-about .text {
  margin-bottom: 100px
}

@media screen and (min-width: 992px) {
  .m-about .text {
    margin-bottom: 0
  }
}

.m-about .text .title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 25px;
  background-color: #fff;
  padding: 18px 30px;
  border-radius: 10px;
  text-align: center;
  color: #262f44
}

.m-about .text .title span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .m-about .text .title {
    font-size: 36px;
    background-color: rgba(0, 0, 0, 0);
    text-align: left;
    color: #fff;
    padding: 0;
    margin-bottom: 15px
  }
}

.m-about .text .desc {
  background: rgba(255, 255, 255, .2);
  padding: 18px;
  border-radius: 10px
}

@media screen and (min-width: 992px) {
  .m-about .text .desc {
    background: rgba(0, 0, 0, 0);
    padding: 0
  }
}

.m-about .about-card-item {
  background: rgba(255, 255, 255, .5);
  padding: 35px 45px;
  border-radius: 10px;
  max-width: 280px;
  min-height: 180px;
  margin-bottom: 25px;
  position: relative;
  transition: all .4s ease;
  margin-left: 60px
}

@media screen and (min-width: 992px) {
  .m-about .about-card-item {
    max-width: 376px;
    min-height: 260px
  }
}

.m-about .about-card-item::before {
  content: "";
  height: 40px;
  width: 40px;
  border-radius: 100px;
  background: #fff;
  position: absolute;
  left: -50px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9
}

@media screen and (min-width: 992px) {
  .m-about .about-card-item::before {
    left: -120px;
    height: 44px;
    width: 44px
  }
}

.m-about .about-card-item::after {
  background: #fff;
  width: 4px;
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  bottom: calc(-50% - 10px);
  left: -32px
}

@media screen and (min-width: 992px) {
  .m-about .about-card-item::after {
    left: -102px;
    width: 8px
  }
}

.m-about .about-card-item h3 {
  color: #262f44;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #06bbc4;
  font-size: 18px;
  font-weight: 700
}

@media screen and (min-width: 992px) {
  .m-about .about-card-item h3 {
    font-size: 25px
  }
}

.m-about .about-card-item .desc {
  color: #7d7d7d;
  line-height: 1.6;
  font-size: 14px
}

@media screen and (min-width: 992px) {
  .m-about .about-card-item .desc {
    font-size: 16px
  }
}

.m-about .about-card-item:last-child::after {
  display: none
}

.m-about .about-card-item.active {
  background: #fff
}

.m-about .about-card-item.active::before {
  background: #06bbc4 !important
}

.m-about .about-card-item.active-state-leave::after {
  background-color: #06bbc4
}

.m-about--2 {
  background: #fff
}

.m-about--2 .text {
  color: #fff
}

.m-about--2 .text .title {
  background-color: #262f44;
  color: #fff
}

.m-about--2 .text .desc {
  background-color: #d9d9d9;
  color: #262f44
}

@media screen and (min-width: 992px) {
  .m-about--2 .text {
    color: #262f44
  }

  .m-about--2 .text .title {
    background-color: rgba(0, 0, 0, 0);
    color: #262f44
  }

  .m-about--2 .text .desc {
    background-color: rgba(0, 0, 0, 0)
  }
}

.m-about--2 .about-card-item {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2)
}

.m-about--2 .about-card-item::before,
.m-about--2 .about-card-item::after {
  box-shadow: 0 5px 5px 0px rgba(0, 0, 0, .1)
}

.m-about--2 .about-card-item.active {
  background-color: #262f44;
  color: #fff
}

.m-about--2 .about-card-item.active h3 {
  color: #fff
}

.m-about--2 .about-card-item.active .desc {
  color: #fff
}

.m-footer {
  color: #fff
}

.m-footer .content {
  padding: 30px 0
}

@media screen and (min-width: 992px) {
  .m-footer .content {
    padding-top: 60px
  }
}

.m-footer .logo {
  margin-bottom: 30px;
  display: block
}

.m-footer p {
  font-size: 14px;
  line-height: 1.6
}

.m-footer .newsletter {
  margin-bottom: 20px
}

.m-footer .newsletter label {
  font-weight: 500;
  font-size: 16px;
  display: block;
  margin-bottom: 5px
}

.m-footer .newsletter .input-group-text {
  background-color: #fff;
  height: 42px
}

.m-footer .newsletter .form-control {
  height: 42px;
  background-color: #fff;
  font-size: 14px;
  border: 0
}

.m-footer .newsletter .form-control:focus {
  outline: none;
  box-shadow: none
}

.m-footer .newsletter .form-control::placeholder {
  color: #d9d9d9
}

.m-footer .newsletter .input-group-button {
  background-color: #06bbc4;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 1px;
  height: 42px;
  border: none;
  font-weight: 500;
  font-size: 10px;
  padding: 0 24px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px
}

.m-footer .social h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px
}

.m-footer ul {
  list-style-type: none;
  padding: 0
}

.m-footer ul li {
  margin-bottom: 18px;
  position: relative;
  padding-left: 28px;
  font-size: 14px
}

.m-footer ul li::before {
  position: absolute;
  left: 0;
  top: 3px;
  content: "";
  display: block;
  height: 14px;
  width: 14px;
  background: url("../../assets/auth/images/icon-chevron-right.svg") no-repeat center center/contain
}

.m-footer ul li a {
  text-decoration: none;
  color: #fff
}

.m-footer ul li a:hover {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .m-footer ul li {
    font-size: 16px
  }

  .m-footer ul li::before {
    top: 4px
  }
}

.m-footer .footer-item {
  margin-bottom: 35px
}

.m-footer .footer-item h2 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 25px
}

@media screen and (min-width: 992px) {
  .m-footer .footer-item {
    padding-right: 32px
  }

  .m-footer .footer-item h2 {
    font-size: 20px
  }
}

.m-footer .copyright {
  margin-top: 50px
}

.m-footer .copyright .content {
  border-top: 1px solid #06bbc4;
  color: #fff;
  padding-top: 30px;
  padding-bottom: 30px;
  font-size: 12px;
  text-align: center
}

@media screen and (min-width: 992px) {
  .m-footer .copyright .content {
    font-size: 16px
  }
}

.home-banner {
  background: #262f44 url("../../assets/auth/images/pattern-honeycomb.svg") repeat;
  background-color: #262f44;
  padding: 76px 6px 130px
}

@media screen and (min-width: 992px) {
  .home-banner {
    padding: 172px 0 110px;
    position: relative
  }

  .home-banner::before {
    background: linear-gradient(90deg, rgb(38, 47, 68) 15%, rgba(58, 104, 210, 0) 100%);
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0
  }
}

@media screen and (min-width: 1200px) {
  .home-banner {
    padding-bottom: 260px
  }
}

.home-banner .image {
  padding: 0 18px;
  display: flex;
  justify-content: center;
  width: 100%
}

@media screen and (min-width: 992px) {
  .home-banner .image {
    max-width: 45%;
    position: relative
  }
}

@media screen and (min-width: 1200px) {
  .home-banner .image {
    max-width: 50%;
    padding: 0
  }
}

.home-banner .text {
  color: #fff;
  padding: 20px 10px;
  position: relative
}

.home-banner .text::before {
  content: "";
  display: block;
  position: absolute;
  left: -4px;
  top: 18px;
  border-top: 50px solid #06bbc4;
  border-right: 66px solid rgba(0, 0, 0, 0);
  width: 0
}

@media screen and (min-width: 1200px) {
  .home-banner .text::before {
    border-top-width: 155px;
    border-right-width: 155px;
    top: 14px;
    left: -14px
  }
}

.home-banner .text h2 {
  font-weight: 600;
  line-height: 1.4;
  font-size: 24px;
  position: relative;
  margin-bottom: 16px
}

.home-banner .text h2 span {
  color: #06bbc4
}

@media screen and (min-width: 1200px) {
  .home-banner .text h2 {
    font-size: 50px;
    margin-bottom: 40px;
    line-height: 1.2
  }
}

.home-banner .text p {
  margin-bottom: 30px
}

@media screen and (min-width: 1200px) {
  .home-banner .text p {
    font-size: 16px;
    margin-bottom: 34px
  }
}

.home-banner .text .info {
  background-color: #1f283c;
  font-weight: 500;
  font-size: 20px;
  line-height: 1.4;
  padding: 12px 16px;
  outline: 5px solid #262f44;
  color: #d9d9d9;
  position: relative;
  left: 5px;
  display: inline-block;
  margin-bottom: 18px
}

.home-banner .text .info::before {
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border: dashed 4px #06bbc4;
  border-image: url(../../assets/auth/images/pattern-border.svg) 3 round
}

@media screen and (min-width: 1200px) {
  .home-banner .text .info {
    font-size: 32px;
    padding: 6px 36px;
    left: 10px;
    margin-bottom: 30px
  }

  .home-banner .text .info::before {
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px
  }
}

.home-banner .text .button-group .c-btn {
  margin-bottom: 10px;
  margin-right: 10px;
  min-width: 195px
}

@media screen and (min-width: 1200px) {
  .home-banner .text .button-group .c-btn {
    min-width: 275px;
    margin-right: 24px
  }
}

@media screen and (min-width: 992px) {
  .home-banner .text {
    max-width: 55%
  }
}

@media screen and (min-width: 1200px) {
  .home-banner .text {
    max-width: 672px
  }
}

.m-section-note {
  position: relative;
  top: -90px;
  z-index: 1;
  margin-bottom: -90px;
  text-align: center
}

.home-section-separator {
  padding-top: 62px;
  padding-bottom: 115px;
  background: #fff
}

@media screen and (min-width: 992px) {
  .home-section-separator {
    padding-bottom: 280px;
    position: relative;
    top: -94px;
    margin-bottom: -94px;
    background: url("../../assets/auth/images/transparent-hexagon-pattern-bg.png") no-repeat right center
  }
}

.home-section-strategy {
  overflow: hidden
}

.home-section-strategy .strategy-content {
  background: #262f44 url("../../assets/auth/images/pattern-wave-dots.png") no-repeat top right;
  padding: 56px 20px 0;
  position: relative
}

@media screen and (min-width: 992px) {
  .home-section-strategy .strategy-content {
    background-image: none
  }

  .home-section-strategy .strategy-content::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("../../assets/auth/images/pattern-wave-dots-2.png") no-repeat top right
  }
}

.home-section-strategy .strategy-pattern {
  margin: -30px -1px 0
}

.home-section-strategy .strategy-list {
  margin-top: 50px
}

.home-section-strategy .strategy-list .list-item {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  position: relative;
  max-width: 344px;
  margin: 0 auto
}

.home-section-strategy .strategy-list .list-item::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 42px;
  right: 0;
  bottom: 0;
  background: url("../../assets/auth/images/pattern-arrow.svg") no-repeat left center/contain
}

.home-section-strategy .strategy-list .list-item::after {
  content: "";
  display: block;
  height: 23px;
  width: 27px;
  background: url("../../assets/auth/images/icon-navigation-arrow-right.svg") no-repeat center center/contain;
  position: absolute;
  bottom: -9.8px;
  left: 0;
  right: 0;
  margin: 0 auto
}

.home-section-strategy .strategy-list .list-item .icon {
  margin-right: 45px;
  max-width: 28px;
  width: 100%
}

.home-section-strategy .strategy-list .list-item .text {
  padding: 18px 0
}

.home-section-strategy .strategy-list .list-item:nth-child(even) {
  margin-top: -2px;
  margin-bottom: -4px;
  flex-direction: row-reverse
}

.home-section-strategy .strategy-list .list-item:nth-child(even) .icon {
  margin-right: 0;
  margin-left: 45px
}

.home-section-strategy .strategy-list .list-item:nth-child(even)::before {
  left: 0;
  bottom: 2px;
  right: 42px;
  background: url("../../assets/auth/images/pattern-arrow-reverse.svg") no-repeat right center/contain
}

.home-section-strategy .strategy-list .list-item:nth-child(even)::after {
  bottom: -8px;
  background: url("../../assets/auth/images/icon-navigation-arrow-left.svg") no-repeat center center/contain
}

.home-section-strategy .strategy-list .list-item:last-child::after {
  display: none
}

@media screen and (min-width: 992px) {
  .home-section-strategy .strategy-list .list-item {
    max-width: 710px;
    font-size: 28px
  }

  .home-section-strategy .strategy-list .list-item::before {
    left: 80px
  }

  .home-section-strategy .strategy-list .list-item::after {
    height: 54px;
    width: 54px;
    bottom: -23.8px
  }

  .home-section-strategy .strategy-list .list-item .icon {
    max-width: 52px;
    margin-right: 85px
  }

  .home-section-strategy .strategy-list .list-item .icon img {
    width: 100%
  }

  .home-section-strategy .strategy-list .list-item .text {
    padding: 40px 0
  }

  .home-section-strategy .strategy-list .list-item:nth-child(even) {
    margin-top: -5px;
    margin-bottom: -8px
  }

  .home-section-strategy .strategy-list .list-item:nth-child(even)::before {
    right: 80px
  }

  .home-section-strategy .strategy-list .list-item:nth-child(even) .icon {
    margin-left: 85px
  }

  .home-section-strategy .strategy-list .list-item:nth-child(even)::after {
    height: 54px;
    width: 54px;
    bottom: -23.8px
  }
}

.home-section-awareness {
  position: relative;
  z-index: 1;
  margin-bottom: -7%
}

.home-section-awareness .content {
  padding: 0 20px
}

.home-section-awareness .content-description {
  max-width: 925px;
  margin: 0 auto 40px
}

@media screen and (min-width: 992px) {
  .home-section-awareness .content-description {
    padding: 0 40px;
    font-size: 16px;
    margin-bottom: 90px
  }
}

.home-section-awareness p {
  text-align: center;
  font-size: 14px;
  color: #7d7d7d;
  line-height: 1.5;
  margin-bottom: 40px
}

.home-section-awareness .awareness-block .image {
  margin-bottom: 30px;
  display: flex;
  justify-content: center
}

@media screen and (min-width: 992px) {
  .home-section-awareness .awareness-block .image img {
    width: 100%
  }
}

@media screen and (min-width: 992px) {
  .home-section-awareness {
    margin-top: -5%
  }
}

.home-section-audit {
  background-color: #262f44;
  margin-top: -30px;
  text-align: center
}

.home-section-audit .content {
  padding: 65px 20px
}

.home-section-audit .content-description {
  max-width: 925px;
  margin: 0 auto 40px
}

@media screen and (min-width: 992px) {
  .home-section-audit .content-description {
    padding: 0 40px;
    font-size: 16px;
    margin-bottom: 90px
  }
}

.home-section-audit .pattern img {
  position: relative;
  top: -1px;
  width: 100%
}

.home-section-audit .pattern-bottom img {
  top: 0;
  bottom: 0
}

.home-section-audit p {
  color: #fff;
  font-size: 14px
}

.home-section-audit .audit-block .image {
  margin-bottom: 30px;
  display: flex;
  justify-content: center
}

.home-section-audit .audit-block .image img {
  width: 100%
}

.home-section-audit .audit-block .text .c-checkbox-content {
  text-align: left;
  color: #fff
}

.home-section-campaign {
  padding-top: 16px;
  margin-bottom: 60px
}

.home-section-campaign .content {
  padding: 0 20px
}

.home-section-campaign .c-section-header {
  margin-bottom: 60px
}

@media screen and (min-width: 992px) {
  .home-section-campaign .campaign-list {
    border-left: 1px solid #d9d9d9;
    padding-left: 40px
  }

  .home-section-campaign .campaign-text {
    padding-right: 40px
  }
}

@media screen and (min-width: 992px) {
  .home-section-campaign .campaign-list {
    padding-left: 50px
  }

  .home-section-campaign .campaign-text {
    padding-right: 50px
  }
}

.home-section-info {
  padding: 0 20px
}

.home-section-info .content {
  border: 1px solid #d9d9d9;
  border-radius: 16px;
  padding: 34px 16px;
  max-width: 1150px;
  margin-left: auto;
  margin-right: auto
}

@media screen and (min-width: 1200px) {
  .home-section-info .content {
    padding: 25px 62px
  }
}

.home-section-info h4 {
  font-size: 26px;
  font-weight: 600;
  color: #262f44;
  text-align: center;
  line-height: 1.8
}

@media screen and (min-width: 1200px) {
  .home-section-info h4 {
    line-height: 1.4
  }
}

.home-section-subscription {
  padding: 60px 20px;
  position: relative
}

.home-section-subscription .content {
  padding: 32px 16px 0;
  border: 2px solid #06bbc4;
  border-radius: 10px;
  position: relative;
  z-index: 1
}

@media screen and (min-width: 992px) {
  .home-section-subscription .content {
    padding: 0;
    border-radius: 46px;
    border: none
  }
}

.home-section-subscription .c-note {
  margin-bottom: 54px;
  background: #fff
}

@media screen and (min-width: 992px) {
  .home-section-subscription .c-note {
    padding: 45px;
    border: 2px solid #06bbc4;
    border-top-left-radius: 46px;
    border-bottom-left-radius: 46px;
    height: 100%;
    border-right: 0;
    display: flex;
    align-items: center
  }
}

.home-section-subscription .form-wrapper {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px
}

@media screen and (min-width: 992px) {
  .home-section-subscription .form-wrapper {
    border-radius: 0
  }
}

.home-section-subscription .form-wrapper .c-form {
  margin: 0 -18px -2px;
  padding: 20px 16px 32px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px
}

@media screen and (min-width: 992px) {
  .home-section-subscription .form-wrapper .c-form {
    margin: 0;
    padding: 85px 45px;
    border-top-right-radius: 46px;
    border-bottom-right-radius: 46px;
    border-bottom-left-radius: 0
  }
}

.home-section-subscription .form-wrapper .c-form label {
  color: #fff
}

.home-section-subscription .form-wrapper .c-form .c-btn {
  border: 0;
  display: block;
  width: 100%;
  margin-top: 24px
}

@media screen and (min-width: 992px) {
  .home-section-subscription .form-wrapper .c-form .c-btn {
    margin-top: 32px
  }
}

@media screen and (min-width: 992px) {
  .home-section-subscription::before {
    content: "";
    display: block;
    width: 65%;
    position: absolute;
    right: 0;
    bottom: 0;
    top: -10%;
    background: url("../../assets/auth/images/pattern-subscription.png") no-repeat top right/contain
  }

  .home-section-subscription::after {
    content: "";
    display: block;
    width: 45%;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    background: url("../../assets/auth/images/pattern-subscription-2.png") no-repeat top left/contain
  }
}

.page-contact .contact-cards {
  margin-bottom: 40px
}

.page-contact .contact-card {
  background-color: #fff;
  padding: 20px;
  border: 2px solid #d9d9d9;
  border-top-right-radius: 16px;
  border-bottom-left-radius: 16px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 16px;
  max-width: 377px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer
}

.page-contact .contact-card .icon {
  margin-bottom: 10px;
  display: flex;
  justify-content: center
}

.page-contact .contact-card .icon img {
  width: 35px;
  height: 35px;
  display: block
}

.page-contact .contact-card .icon img.second-icon {
  display: none
}

@media screen and (min-width: 992px) {
  .page-contact .contact-card .icon img {
    width: 50px;
    height: 50px
  }
}

.page-contact .contact-card:hover,
.page-contact .contact-card.active {
  border-color: #06bbc4;
  color: #06bbc4
}

.page-contact .contact-card:hover .icon img.main-icon,
.page-contact .contact-card.active .icon img.main-icon {
  display: none
}

.page-contact .contact-card:hover .icon img.second-icon,
.page-contact .contact-card.active .icon img.second-icon {
  display: block
}

@media screen and (min-width: 576px) {
  .page-contact .contact-card {
    margin-bottom: 32px
  }
}

@media screen and (min-width: 768px) {
  .page-contact .contact-card {
    border-top-right-radius: 20px;
    border-bottom-left-radius: 20px;
    font-size: 14px
  }
}

@media screen and (min-width: 992px) {
  .page-contact .contact-card {
    border-top-right-radius: 30px;
    border-bottom-left-radius: 30px;
    font-size: 16px;
    margin-bottom: 40px
  }
}

@media screen and (min-width: 1200px) {
  .page-contact .contact-card {
    font-size: 20px;
    margin-bottom: 58px
  }
}

.page-contact .form .form-group {
  margin-bottom: 16px
}

.page-contact .form .form-group .form-control {
  min-height: 50px;
  box-shadow: none;
  outline: none;
  padding: 5px 10px
}

.page-contact .form .form-group textarea.form-control {
  min-height: 120px;
  padding: 10px
}

.page-contact .form .form-group .c-btn {
  min-height: 50px;
  max-width: 520px;
  margin-left: auto;
  margin-right: auto;
  display: block
}

@media screen and (min-width: 992px) {
  .page-contact .form .form-group {
    margin-bottom: 20px
  }

  .page-contact .form .form-group .form-control {
    height: 60px;
    padding: 10px 15px
  }

  .page-contact .form .form-group textarea.form-control {
    min-height: 158px;
    padding: 10px 15px
  }

  .page-contact .form .form-group .c-btn {
    margin-top: 30px
  }
}

.page-faq {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 0
}

@media screen and (min-width: 992px) {
  .page-faq {
    padding-left: 0;
    padding-right: 0
  }
}

.page-faq .faq-group {
  margin-bottom: 30px
}

@media screen and (min-width: 992px) {
  .page-faq .faq-group {
    margin-bottom: 45px
  }
}

.page-faq .faq-group .group-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.4
}

.page-faq .faq-group .group-title span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .page-faq .faq-group .group-title {
    font-size: 28px;
    line-height: 1.4
  }
}

.page-faq .faq-note {
  position: relative;
  padding-bottom: 55px;
  margin-left: -16px;
  margin-right: -16px;
  margin-top: 100px
}

.page-faq .faq-note::before {
  content: "";
  display: block;
  min-height: 192px;
  background: #06bbc4;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0
}

@media screen and (min-width: 992px) {
  .page-faq .faq-note {
    margin-left: 0;
    margin-right: 0;
    margin-top: 255px
  }
}

.page-faq .faq-note .content {
  position: relative;
  border-radius: 10px;
  padding: 42px 30px;
  overflow: hidden;
  font-size: 18px;
  color: #fff
}

.page-faq .faq-note .content p {
  margin-bottom: 24px
}

.page-faq .faq-note .content p span {
  color: #06bbc4;
  font-weight: 600
}

.page-faq .faq-note .content button {
  border: 0;
  background-color: #06bbc4;
  padding: 10px 18px;
  border-radius: 50px;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
  box-shadow: 0 10px 20px -10px #06bbc4;
  color: #262f44;
  transition: all .4s ease
}

.page-faq .faq-note .content button:hover {
  background-color: #fff;
  color: #06bbc4;
  box-shadow: 0 15px 20px -10px #06bbc4
}

@media screen and (min-width: 992px) {
  .page-faq .faq-note .content button {
    font-size: 18px
  }
}

.page-faq .faq-note .content>* {
  position: relative;
  z-index: 1
}

.page-faq .faq-note .content::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: "";
  display: block;
  background-color: rgba(38, 47, 68, .9);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px)
}

@media screen and (min-width: 992px) {
  .page-faq .faq-note .content {
    padding: 42px 65px 80px;
    font-size: 28px
  }
}

.page-terms {
  padding-bottom: 100px;
  padding-left: 16px;
  padding-right: 16px
}

@media screen and (min-width: 992px) {
  .page-terms {
    paddinb-bottom: 255px;
    padding-left: 0;
    padding-right: 0
  }
}

.page-terms .page-header {
  margin-bottom: 40px
}

.page-terms p {
  color: #7d7d7d
}

.page-terms .c-card-block {
  margin-bottom: 40px
}

.page-terif .header-section {
  position: relative
}

.page-terif .header-section .pattern {
  display: none
}

@media screen and (min-width: 992px) {
  .page-terif .header-section .pattern {
    position: absolute;
    display: block
  }

  .page-terif .header-section .pattern-1 {
    bottom: 0;
    left: 0
  }

  .page-terif .header-section .pattern-2 {
    bottom: 0;
    right: 0
  }
}

.page-terif .c-section-header {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 18px
}

@media screen and (min-width: 992px) {
  .page-terif .c-section-header {
    font-size: 38px
  }
}

.page-terif .excerpt {
  max-width: 775px;
  margin: 0 auto;
  text-align: center;
  border-radius: 12px;
  border: 1px solid #d9d9d9;
  padding: 10px 14px;
  margin-bottom: 45px;
  font-size: 12px;
  color: #7d7d7d
}

@media screen and (min-width: 992px) {
  .page-terif .excerpt {
    font-size: 16px
  }
}

.page-terif .c-switch-toggler {
  margin-bottom: 75px
}

.page-terif .section-note .content {
  background-color: #374b68;
  padding: 20px;
  border-radius: 20px;
  color: #fff
}

.page-terif .section-note .content h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 18px
}

.page-terif .section-note .content h2 span {
  color: #06bbc4
}

.page-terif .section-note .content p {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  margin-bottom: 50px
}

.page-terif .section-note .content .c-btn {
  min-width: 100%
}

@media screen and (min-width: 992px) {
  .page-terif .section-note .content {
    padding: 42px 50px
  }

  .page-terif .section-note .content h2 {
    font-size: 34px
  }

  .page-terif .section-note .content p {
    font-size: 18px
  }

  .page-terif .section-note .content .c-btn {
    min-width: 380px
  }
}

.page-terif .package-tab h3 {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin: 0 0 13px;
  text-align: center
}

.page-terif .package-tab .c-tab {
  display: flex;
  flex-direction: column;
  justify-content: center
}

.page-terif .package-tab .c-tab .tab-header {
  margin: 0 auto;
  overflow: auto;
  width: 100%
}

@media screen and (min-width: 992px) {
  .page-terif .package-tab .c-tab .tab-header {
    width: auto
  }
}

.page-auth {
  padding: 25px 16px
}

@media screen and (min-width: 992px) {
  .page-auth {
    height: 100vh;
    display: flex;
    align-items: center
  }
}

.page-auth .content {
  background-color: #262f44;
  border-radius: 30px
}

.page-auth .content-left {
  padding: 40px 35px;
  background: url("../../assets/auth/images/pattern-honeycomb.svg") no-repeat top right/contain;
  display: none
}

@media screen and (min-width: 992px) {
  .page-auth .content-left {
    display: block
  }
}

.page-auth .content-right {
  background: #fff;
  border-radius: 30px;
  border: 5px solid #262f44;
  padding: 35px 20px;
  position: relative
}

.page-auth .content-right::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("../../assets/auth/images/background-auth-1.svg") no-repeat left top, url("../../assets/auth/images/background-auth-2.svg") no-repeat right bottom
}

@media screen and (min-width: 992px) {
  .page-auth .content-right {
    padding-left: 80px;
    padding-right: 80px
  }
}

.page-auth .content .logo-wrapper {
  margin-bottom: 72px
}

.page-auth .content .logo {
  max-width: 412px;
  width: 100%
}

.page-auth .content .banner-wrapper {
  margin-bottom: 30px
}

.page-auth .content .note {
  font-weight: 500;
  color: #fff;
  position: relative;
  z-index: 1;
  padding-left: 4px;
  font-size: 26px
}

.page-auth .content .note::before {
  content: "";
  display: block;
  border-top: 35px solid #06bbc4;
  border-right: 35px solid rgba(0, 0, 0, 0);
  width: 0;
  height: 34px;
  width: 34px;
  position: absolute;
  z-index: -1;
  top: 2px;
  left: -2px
}

.page-auth .content .note span {
  color: #06bbc4
}

.page-auth .content h4 {
  font-size: 28px;
  color: #7d7d7d;
  font-weight: 600;
  margin-bottom: 10px
}

.page-auth .content h2 {
  color: #06bbc4;
  font-size: 36px;
  font-weight: 600;
  position: relative;
  padding-bottom: 20px
}

.page-auth .content .separator {
  background: #262f44;
  margin-bottom: 40px;
  height: 5px;
  width: 168px;
  position: relative;
  display: flex
}

.page-auth .content .separator::after {
  content: "";
  display: inline-block;
  height: 5px;
  width: 5px;
  background-color: #262f44;
  position: absolute;
  top: 0;
  right: -10px
}

.page-auth .content .c-form {
  position: relative;
  z-index: 1
}

@keyframes marquee {
  0% {
    transform: translateX(0)
  }

  100% {
    transform: translateX(calc(-100% + 580px))
  }
}

.page-product-inner {
  padding-bottom: 0;
  padding-top: 0
}

.page-product-inner .banner {
  position: relative;
  background-color: #262f44;
  overflow: hidden
}

.page-product-inner .banner::before,
.page-product-inner .banner::after {
  content: "";
  display: block;
  height: 160px;
  width: 160px;
  background-color: #06bbc4;
  border-radius: 100%;
  filter: blur(70px);
  position: absolute;
  left: -80px;
  top: 12%
}

@media screen and (min-width: 992px) {

  .page-product-inner .banner::before,
  .page-product-inner .banner::after {
    height: 308px;
    width: 320px
  }
}

.page-product-inner .banner::after {
  right: -50px;
  left: auto;
  height: 100px;
  width: 100px;
  top: 60%;
  transform: translateY(-50%)
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner::after {
    height: 242px;
    width: 264px;
    right: -150px
  }
}

.page-product-inner .banner .banner-content {
  padding-top: 100px;
  padding-bottom: 50px;
  position: relative;
  z-index: 1
}

.page-product-inner .banner .banner-content.pb-0 {
  padding-bottom: 0
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content {
    padding-top: 170px;
    padding-bottom: 112px;
    min-height: 100vh
  }

  .page-product-inner .banner .banner-content.pb-lg-0 {
    padding-bottom: 0
  }
}

.page-product-inner .banner .banner-content .text {
  color: #fff;
  margin-bottom: 35px
}

.page-product-inner .banner .banner-content .text.pb-5 {
  padding-bottom: 60px !important
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content .text {
    padding-right: 50px;
    margin-bottom: 0
  }
}

.page-product-inner .banner .banner-content img {
  max-width: auto;
  margin-bottom: 30px
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content img {
    margin-bottom: 0
  }
}

.page-product-inner .banner .banner-content h2 {
  font-size: 35px;
  font-weight: 400;
  margin-bottom: 30px
}

.page-product-inner .banner .banner-content h2 span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content h2 {
    font-size: 70px
  }
}

.page-product-inner .banner .banner-content h3 {
  font-size: 35px;
  font-weight: 600;
  margin-bottom: 30px
}

.page-product-inner .banner .banner-content h3 span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content h3 {
    font-size: 50px
  }
}

.page-product-inner .banner .banner-content h4 {
  font-size: 18px;
  font-weight: 600
}

.page-product-inner .banner .banner-content h4 span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content h4 {
    font-size: 35px
  }
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content .desc {
    font-size: 70px;
    padding-right: 150px;
    font-size: 20px
  }
}

.page-product-inner .banner .banner-content .banner-desc {
  color: #fff;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 10px
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content .banner-desc {
    font-size: 28px
  }
}

.page-product-inner .banner .banner-content__section {
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  color: #fff;
  padding-bottom: 100px
}

.page-product-inner .banner .banner-content__section p {
  margin-bottom: 30px
}

.page-product-inner .banner .banner-content__section p span {
  color: #06bbc4
}

.page-product-inner .banner .banner-content__section p:last-child {
  margin: 0
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content__section {
    font-size: 26px;
    padding-bottom: 120px
  }

  .page-product-inner .banner .banner-content__section p {
    margin-bottom: 58px
  }
}

.page-product-inner .banner .banner-content__section--2 {
  text-align: left;
  color: #262f44;
  padding: 30px;
  margin-bottom: 50px
}

.page-product-inner .banner .banner-content__section--2 p {
  margin-bottom: 25px
}

@media screen and (min-width: 992px) {
  .page-product-inner .banner .banner-content__section--2 {
    font-size: 30px;
    margin-bottom: 150px;
    padding: 60px 40px
  }
}

.page-product-inner .banner .cards-wrapper {
  overflow: hidden;
  padding: 0 10px 44px
}

.page-product-inner .banner .cards-wrapper .row {
  margin: 0 -10px;
  animation: marquee 50s linear infinite alternate;
  animation-fill-mode: forwards
}

.page-product-inner .banner .cards-wrapper .row .column {
  padding: 0 10px;
  max-width: 290px
}

.page-product-inner .banner .cards-wrapper .row .column .c-icon-card {
  height: 100%
}

.page-product-inner .awareness-section {
  margin: 0 auto
}

.page-product-inner .awareness-section .c-section-header {
  font-weight: 600;
  max-width: 1100px;
  color: #fff;
  margin-bottom: 35px
}

@media screen and (min-width: 992px) {
  .page-product-inner .awareness-section .c-section-header {
    font-size: 42px;
    margin-bottom: 70px
  }
}

.page-product-inner .demand-section {
  padding-top: 50px;
  margin-bottom: 50px;
  text-align: center;
  font-weight: 600;
  color: #262f44;
  font-size: 18px
}

@media screen and (min-width: 992px) {
  .page-product-inner .demand-section {
    font-size: 28px;
    margin-bottom: 100px
  }
}

.page-product-inner .demand-section h3 {
  line-height: 1.4;
  margin-bottom: 35px
}

.page-product-inner .demand-section h3 span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .page-product-inner .demand-section h3 {
    margin-bottom: 35px
  }
}

.page-product-inner .platforms {
  margin-bottom: 50px
}

@media screen and (min-width: 992px) {
  .page-product-inner .platforms {
    margin-bottom: 100px
  }
}

.page-product-inner .platforms .content {
  border-radius: 15px;
  background-color: #262f44;
  color: #fff;
  padding: 50px 24px
}

@media screen and (min-width: 992px) {
  .page-product-inner .platforms .content {
    padding: 50px 85px
  }
}

.page-product-inner .platforms .content .c-section-header {
  max-width: 950px;
  margin-bottom: 35px
}

@media screen and (min-width: 992px) {
  .page-product-inner .platforms .content .c-section-header {
    font-size: 32px;
    margin-bottom: 85px
  }
}

.page-product-inner .platforms .content .cards-wrapper [class^=col-] {
  margin-bottom: 30px
}

.page-product-inner .platforms .content .card {
  background-color: #313a4e;
  padding: 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #c1c4ca;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  justify-content: center
}

@media screen and (min-width: 992px) {
  .page-product-inner .platforms .content .card {
    font-size: 18px
  }
}

.page-product-inner .m-information-box {
  margin-bottom: 50px
}

@media screen and (min-width: 992px) {
  .page-product-inner .m-information-box {
    margin-bottom: 125px
  }
}

.page-product-inner .notes {
  background-color: #262f44;
  color: #fff;
  padding: 40px 0;
  position: relative
}

.page-product-inner .notes.notes-white {
  background-color: #fff;
  color: #262f44
}

.page-product-inner .notes.notes-bordered .content {
  border: 1px solid #9ea7b7;
  border-radius: 40px;
  padding: 40px 30px 100px
}

@media screen and (min-width: 992px) {
  .page-product-inner .notes.notes-bordered .content {
    padding: 100px 80px
  }
}

.page-product-inner .notes::before,
.page-product-inner .notes::after {
  content: "";
  display: block;
  height: 160px;
  width: 160px;
  background-color: #06bbc4;
  border-radius: 100%;
  filter: blur(160px);
  position: absolute;
  left: -80px;
  top: 12%
}

@media screen and (min-width: 992px) {

  .page-product-inner .notes::before,
  .page-product-inner .notes::after {
    height: 308px;
    width: 320px
  }
}

.page-product-inner .notes::after {
  right: -50px;
  left: auto;
  height: 100px;
  width: 100px;
  top: 50%;
  transform: translateY(-50%)
}

@media screen and (min-width: 992px) {
  .page-product-inner .notes::after {
    height: 242px;
    width: 264px;
    right: -160px
  }
}

.page-product-inner .notes.notes-glow-no::before,
.page-product-inner .notes.notes-glow-no::after {
  display: none
}

@media screen and (min-width: 992px) {
  .page-product-inner .notes {
    padding: 70px 0
  }
}

.page-product-inner .notes h3 {
  font-size: 18px;
  line-height: 1.6;
  font-weight: 600;
  margin-bottom: 25px
}

.page-product-inner .notes h3 span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .page-product-inner .notes h3 {
    font-size: 25px
  }
}

.page-product-inner .section-note {
  position: relative;
  padding-bottom: 50px
}

@media screen and (min-width: 992px) {
  .page-product-inner .section-note {
    padding-bottom: 25px
  }

  .page-product-inner .section-note::before {
    content: "";
    display: block;
    left: 0;
    right: 0;
    top: 50%;
    bottom: 0;
    position: absolute;
    background-color: #262f44
  }
}

.page-product-inner .section-note .content {
  background-color: #fff;
  padding: 30px;
  text-align: center;
  border-radius: 24px;
  position: relative;
  border: 1px solid #7d7d7d
}

@media screen and (min-width: 992px) {
  .page-product-inner .section-note .content {
    box-shadow: 0 0 20px 0px rgba(0, 0, 0, .25);
    border: none;
    padding: 40px 100px
  }
}

.page-product-inner .section-note .content h2 {
  color: #262f44;
  font-weight: 700;
  margin-bottom: 40px;
  font-size: 14px;
  line-height: 1.4
}

.page-product-inner .section-note .content h2 span {
  color: #06bbc4
}

@media screen and (min-width: 992px) {
  .page-product-inner .section-note .content h2 {
    font-size: 35px
  }
}

.page-product-inner .section-note--style-2 .content {
  border-radius: 40px;
  border-bottom-left-radius: 0
}

/*# sourceMappingURL=style.css.map */
</style>